import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { useNavigate, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';

// Import icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ApartmentIcon from '@mui/icons-material/Apartment';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import PaymentIcon from '@mui/icons-material/Payment';
import BuildIcon from '@mui/icons-material/Build';
import MessageIcon from '@mui/icons-material/Message';
import BookOnlineRoundedIcon from '@mui/icons-material/BookOnlineRounded';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import LogoutIcon from '@mui/icons-material/Logout';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import PasswordIcon from '@mui/icons-material/Password';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
export default function Sidebar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const drawerWidth = {
    xs: '80vw', // استخدام نسبة للعرض في الشاشات الصغيرة
    md: '19vw', // نسبة مئوية للعرض في الشاشات الأكبر
  };

  useEffect(() => {
    setSelectedItem(location.pathname);
  }, [location]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = async () => {
    try {
      // Clear local storage
      localStorage.clear();
      // Navigate to login page
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const menuItems = [
    { name: t('dashboard'), to: '/dashboard', icon: <DashboardIcon /> },
    { name: t('units'), to: '/units', icon: <ApartmentIcon /> },
    { name: t('Payments'), to: '/payment', icon: <PaymentIcon /> },
    { name: t('maintenance'), to: '/maintenance', icon: <BuildIcon /> },
    // { name: 'Messages', to: '/newsType', icon: <MessageIcon /> },
    // { name: 'Analyses', to: '/analysis', icon: <AnalyticsIcon /> },
    { name: t('profile'), to: '/profile', icon: <AccountBoxIcon /> },
    // { name: 'Change Password', to: '/changepassword', icon: <PasswordIcon /> },
    { name: t('contracts'), to: '/contract', icon: <PictureAsPdfIcon/> },
    // { name: 'Payment Lists', to: '/payment', icon: <MonetizationOnOutlinedIcon /> },
    // { name: t('Chat'), to: '/chat', icon: <MessageIcon /> },
    { name: t('Analysis'), to: '/reservation', icon: <AttachMoneyIcon/> },
    // { name: t('Notification'), to: '/notification', icon: <BookOnlineRoundedIcon /> },
    { name: t('logout'), icon: <LogoutIcon />, onClick: handleLogout },
  ];

  const handleItemClick = (path) => {
    setSelectedItem(path);
    setMobileOpen(false);
    navigate(path);
  };

  const drawer = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Logo/Avatar Container */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 2, md: 3 },
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
          // backgroundColor:"yellow",
          // padding:"0px"

        }}
      >
        <img
          alt="Logo"
          src="/assets/Bask 01-02 1.png"
          style={{
            width: '100%',
            height: '90%',
            maxWidth: '100%',
            maxHeight: 80,
            objectFit: 'contain',
            // backgroundColor:"blue"
          }}
        />
      </Box>

      {/* Menu Items */}
      <List sx={{ flexGrow: 1,py: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
          {menuItems.filter(item => item.name !== t('logout')).map((item, index) => (
            <ListItem
              key={index}
              disablePadding
              sx={{ mb: 0.5 }}
            >
              <ListItemButton
                onClick={() => item.onClick ? item.onClick() : handleItemClick(item.to)}
                sx={{
                  borderRadius: 1,
                  backgroundColor: selectedItem === item.to ? '#C47D60' : 'transparent',
                  '&:hover': {
                    backgroundColor: selectedItem === item.to
                      ? '#C47D60'
                      : 'rgba(196, 125, 96, 0.08)'
                  },
                  py: { xs: 1, md: 1.5 },
                  px: { xs: 1.5, md: 2 },
                  '& .MuiListItemIcon-root': {
                    minWidth: { xs: 40, md: 45 },
                    marginRight: "10px",
                    color: selectedItem === item.to ? 'white' : 'inherit',
                  },
                  '& .MuiListItemText-primary': {
                    fontSize: { xs: '0.875rem', md: '1rem' },
                    fontWeight: selectedItem === item.to ? 600 : 400,
                    color: selectedItem === item.to ? 'white' : 'inherit',
                    textAlign: i18n.language === 'ar' ? 'right' : 'left',
                  }
                }}
              >
                {i18n.language === 'ar' ? (
                  <>
                    <ListItemText primary={item.name} />
                    <ListItemIcon>{item.icon}</ListItemIcon>
                  </>
                ) : (
                  <>
                    <ListItemText primary={item.name} />
                    <ListItemIcon>{item.icon}</ListItemIcon>
                  </>
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </div>

        <div>
          {menuItems.filter(item => item.name === t('logout')).map((item, index) => (
            <ListItem
              key={index}
              disablePadding
              sx={{ mb: 0.5 }}
            >
              <ListItemButton
                onClick={item.onClick}
                sx={{
                  borderRadius: 1,
                  '&:hover': {
                    backgroundColor: 'rgba(196, 125, 96, 0.08)'
                  },
                  py: { xs: 1, md: 1.5 },
                  px: { xs: 1.5, md: 2 },
                  '& .MuiListItemIcon-root': {
                    minWidth: { xs: 40, md: 45 },
                    marginRight: "10px",
                  },
                  '& .MuiListItemText-primary': {
                    fontSize: { xs: '0.875rem', md: '1rem' },
                    textAlign: i18n.language === 'ar' ? 'right' : 'left',
                  }
                }}
              >
                {i18n.language === 'ar' ? (
                  <>
                    <ListItemText primary={item.name} />
                    <ListItemIcon>{item.icon}</ListItemIcon>
                  </>
                ) : (
                  <>
                    <ListItemText primary={item.name} />
                    <ListItemIcon>{item.icon}</ListItemIcon>
                  </>
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </div>
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          display: { md: 'none' },
          backgroundColor: 'var(--pri-col)',
          boxShadow: 1,
          zIndex: (theme) => theme.zIndex.drawer + 1
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Box
        component="nav"
        sx={{
          width: { sm: drawerWidth.xs, md: drawerWidth.md },
          flexShrink: { sm: 0 }
        }}
      >
        {/* Mobile Drawer */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better mobile performance
          }}
          xs={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth.xs,
              backgroundColor: 'background.paper',
              boxShadow: 3
            },
          }}
        >
          {drawer}
        </Drawer>

        {/* Desktop Drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', md: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth.md,
              backgroundColor: 'background.paper',
              boxShadow: 1,
              border: 'none'
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

    </>
  );
}

Sidebar.propTypes = {
  window: PropTypes.func,
};